import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js') // Ensure that your service worker file is in the root directory
      .then((registration) => {
        console.log('Service Worker registered with scope:', registration.scope);
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
} else {
  console.log('Service Worker is not supported in this browser.');
  window.addEventListener('error', function (e) {
    console.error('Window Error:', e.error || e.message);
  });
  window.addEventListener('unhandledrejection', function (e) {
    console.error('Unhandled Promise Rejection:', e.reason);
  });
}


const rootElement = document.getElementById('root');

// const hasRealContent = rootElement.childElementCount > 0 &&
//                        rootElement.innerHTML.trim().length > 0 && navigator.userAgent === 'ReactSnap';
// if (rootElement.hasChildNodes()) {
//   hydrateRoot(
//     rootElement,
//     <React.StrictMode>
//       <App />
//     </React.StrictMode>
//   );
// } else {
  // Normal client render
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

reportWebVitals();
serviceWorkerRegistration.register();